import { useRef, useEffect } from 'react';

const useIEObjectFitPolyfill = <F, P>({
  objectFit,
  objectPosition,
}: {
  objectFit: F;
  objectPosition: P;
}): {
  imgRef: { current: any };
  polyfillStyle: {
    fontFamily: string;
    objectFit: F;
    objectPosition: P;
  };
} => {
  const imgRef = useRef<any>(null);
  useEffect(() => {
    const testImg = document.createElement(`img`);
    if (
      typeof testImg.style.objectFit === `undefined` ||
      typeof testImg.style.objectPosition === `undefined`
    ) {
      import(`object-fit-images`).then(({ default: ObjectFitImages }) =>
        ObjectFitImages(imgRef.current),
      );
    }
  }, [imgRef]);
  return {
    imgRef,
    polyfillStyle: {
      objectFit,
      objectPosition,
      fontFamily: `"object-fit: ${objectFit}; object-position: ${objectPosition}"`,
    },
  };
};

export default useIEObjectFitPolyfill;
